import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { getLocations as getLocationsApi, updateLocationApi, addLocationApi, deleteLocationApi } from "../../helpers/api/locations";

// constants
import { LocationsActionTypes } from "./constants";
import { getLocations, LocationsApiResponseSuccess, LocationsApiResponseError } from "./actions";
import { MAX_ITEMS_PER_PAGE } from "../../helpers/api/apiCore";

// Fetch locations saga
function* getLocationsSaga({ payload: { status, page, limit } }: any): SagaIterator {
  try {
    const response = yield call(getLocationsApi, status, page, limit);
    const locations = response?.data;

    yield put(LocationsApiResponseSuccess(LocationsActionTypes.GET_LOCATIONS, locations));
  } catch (error: any) {
    yield put(LocationsApiResponseError(LocationsActionTypes.GET_LOCATIONS, error));
  }
}

// Update location saga
function* updateLocationSaga({
  payload: { id, name, latitude, longitude, address, phone, starting_hour, ending_hour, is_active, code },
}: any): SagaIterator {
  try {
    const response = yield call(updateLocationApi, { id, name, latitude, longitude, address, phone, starting_hour, ending_hour, is_active, code });
    const message = response?.data?.message;

    yield put(LocationsApiResponseSuccess(LocationsActionTypes.UPDATE_LOCATIONS, message));
    yield put(getLocations(undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(LocationsApiResponseError(LocationsActionTypes.UPDATE_LOCATIONS, error));
  }
}

// Add new location saga
function* addLocationSaga({
  payload: { name, latitude, longitude, address, phone, starting_hour, ending_hour, is_active, code },
}: any): SagaIterator {
  try {
    const response = yield call(addLocationApi, { name, latitude, longitude, address, phone, starting_hour, ending_hour, is_active, code });
    const message = response?.data?.message;

    yield put(LocationsApiResponseSuccess(LocationsActionTypes.ADD_LOCATIONS, message));
    yield put(getLocations(undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(LocationsApiResponseError(LocationsActionTypes.ADD_LOCATIONS, error));
  }
}
// Delete location saga
function* deleteLocationSaga({ payload: { id } }: any): SagaIterator {
  try {
    const response = yield call(deleteLocationApi, { id });
    const message = response?.data?.message;

    yield put(LocationsApiResponseSuccess(LocationsActionTypes.DELETE_LOCATIONS, message));
    yield put(getLocations(undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(LocationsApiResponseError(LocationsActionTypes.DELETE_LOCATIONS, error));
  }
}

// Watchers
export function* watchGetLocations() {
  yield takeEvery(LocationsActionTypes.GET_LOCATIONS, getLocationsSaga);
}

export function* watchUpdateLocation() {
  yield takeEvery(LocationsActionTypes.UPDATE_LOCATIONS, updateLocationSaga);
}

export function* watchAddLocation() {
  yield takeEvery(LocationsActionTypes.ADD_LOCATIONS, addLocationSaga);
}

export function* watchDeleteLocation() {
  yield takeEvery(LocationsActionTypes.DELETE_LOCATIONS, deleteLocationSaga);
}

// Root saga
function* LocationsSaga() {
  yield all([fork(watchGetLocations), fork(watchUpdateLocation), fork(watchAddLocation), fork(watchDeleteLocation)]);
}

export default LocationsSaga;
